// AIによる道路追加で使用するstore
/** @typedef {import("@/components/Project/road-ai/roadAi.types").RoadAiRunState} RoadAiRunState v1.2 追加分の状態の単一定義 */
const state = {
	// 設計データ
	designFilename: "",
	// 地形データ
	pointCloudItem: "",
	//地形情報
	terrainItems: [
		{
			name: "terrain_x_value_min",
			value: "",
		},
		{
			name: "terrain_x_value_max",
			value: "",
		},
		{
			name: "terrain_y_value_min",
			value: "",
		},
		{
			name: "terrain_y_value_max",
			value: "",
		},
		{
			name: "design_x_value_min",
			value: "",
		},
		{
			name: "design_x_value_max",
			value: "",
		},
		{
			name: "design_y_value_min",
			value: "",
		},
		{
			name: "design_y_value_max",
			value: "",
		},
		{
			name: "terrain_height_min",
			value: "",
		},
		{
			name: "terrain_height_max",
			value: "",
		},
		{
			name: "design_height_min",
			value: "",
		},
		{
			name: "design_height_max",
			value: "",
		},
	],
	isAIRoadPreviewMode: false,
	// チャットコンテキスト（メッセージ履歴）
	chatContext: [],
	// 送信用のチャットコンテキスト（ユーザーに見えないコンテキストを含む）
	postChatContext: [],
	// パラメータコマンド（デフォルト"6"）。getter / mutation と名前を揃える。
	commandId: 6, // TODO(D3D-774): 旧 ai-road 用。新方式では未使用。将来削除。
	// ルートパラメータ（デフォルト"0.1"）
	route: 0.1, // TODO(D3D-774): 旧 ai-road 用。新方式では未使用。将来削除。
	// 勾配パラメータ（デフォルト"14"）
	grade: 14, // TODO(D3D-774): 旧 ai-road 用。新方式では未使用。将来削除。
	// 道幅パラメータ（デフォルト"4.0"）
	width: 4.0, // TODO(D3D-774): 旧 ai-road 用。新方式では未使用。将来削除。
	// --- 新方式（D3D-774 Hybrid A* プロトタイプ）で使用 ---
	// 会話から抽出する実行パラメータ（既定値）
	objectives: ["cut", "fill", "over_cut", "over_fill", "cf_diff"],
	roadWidthM: 4.0,
	maxSlopePercent: 14.0,
	// 始終点（プロジェクト射影座標 [x, y, z]）。点選択で設定する
	aiStart: null,
	aiEnd: null,
	// v1.1: 順序付き中継点 [[x,y,z], …]（0..5）
	waypoints: [],
	// --- v1.2: 表示中データの利用・点群のみモード・非同期実行（形は RoadAiRunState が単一の正） ---
	/** @type {RoadAiRunState["mode"]} 検査で確定したモード */
	mode: null,
	/** @type {RoadAiRunState["dataSelection"]} 実行に使用するデータ */
	dataSelection: null,
	// チャットで「点群だけで検討したい」と伝えられたか（AC-35）
	pointCloudOnlyRequested: false,
	/** @type {RoadAiRunState["candidateState"]} 候補経路の正規化状態 */
	candidateState: { ids: [], entities: {} },
	diagnostics: [],
	/** @type {RoadAiRunState["usedSource"]} 実行に実際に使われたアセット（AC-15） */
	usedSource: null,
	/** @type {RoadAiRunState["jobHandle"]} ポーリング中のジョブ */
	jobHandle: null,
	/** @type {RoadAiRunState["runError"]} 実行中止の理由（AC-11） */
	runError: null,
	// 実行中フラグ（多重実行防止・ローディング）。受付からジョブ完了まで true（AC-41）
	isRunning: false,
	// 仮設道路AIに利用するID情報
	pointCloudAssetId: undefined,
	pointCloudId: undefined,
	designId: undefined,
	aiParameter: {
		isComplete: false,
		file: null,
		isTempRoadBtnDisabled: true,
		inputTextField: {
			xValueMin: "",
			xValueMax: "",
			yValueMin: "",
			yValueMax: "",
			xyInterval: "",
			zValueMin: "",
			zValueMax: "",
			zInterval: "",
			allowMaxGradient: "",
			searchExpansionRadius: "",
		},
		terrainInfo: null,
		sliderMin: 0.1,
		sliderMax: 1.0,
		sliderStep: 0.01,
		sliderValueCut: 0.1,
		sliderValueFill: 0.1,
		sliderValueOverFill: 0.1,
		sliderValueOverCut: 0.1,
		sliderValueCfDiff: 1.0,
		sliderValueRoute: 0.1,
	},
	leftWith: 2.5,
	rightWith: 2.5,
	cutVolume: 0,
	fillVolume: 0,
};

const getters = {
	designFilename: (state) => state.designFilename,
	pointCloudItem: (state) => state.pointCloudItem,
	terrainItems: (state) => state.terrainItems,
	isAIRoadPreviewMode: (state) => state.isAIRoadPreviewMode,
	chatContext: (state) => state.chatContext,
	postChatContext: (state) => state.postChatContext,
	commandId: (state) => state.commandId,
	route: (state) => state.route,
	grade: (state) => state.grade,
	width: (state) => state.width,
	// 新方式（D3D-774）
	objectives: (state) => state.objectives,
	roadWidthM: (state) => state.roadWidthM,
	maxSlopePercent: (state) => state.maxSlopePercent,
	aiStart: (state) => state.aiStart,
	aiEnd: (state) => state.aiEnd,
	waypoints: (state) => state.waypoints,
	mode: (state) => state.mode,
	dataSelection: (state) => state.dataSelection,
	pointCloudOnlyRequested: (state) => state.pointCloudOnlyRequested,
	candidateState: (state) => state.candidateState,
	// 表示コンポーネント互換の配列を正規化状態から組み立てる派生 getter。
	candidates: (state) =>
		state.candidateState.ids
			.map((id) => state.candidateState.entities[id])
			.filter((entity) => Boolean(entity))
			.map((entity) => ({
				objective: entity.objective,
				points: entity.points,
				metrics_final: entity.metricsFinal,
				node_count: entity.nodeCount,
				violations: entity.violations,
				is_fallback: entity.isFallback,
			})),
	diagnostics: (state) => state.diagnostics,
	usedSource: (state) => state.usedSource,
	jobHandle: (state) => state.jobHandle,
	runError: (state) => state.runError,
	isRunning: (state) => state.isRunning,
	pointCloudAssetId: (state) => state.pointCloudAssetId,
	pointCloudId: (state) => state.pointCloudId,
	designId: (state) => state.designId,
	aiParameter: (state) => state.aiParameter,
	leftWith: (state) => state.leftWith,
	rightWith: (state) => state.rightWith,
	cutVolume: (state) => state.cutVolume,
	fillVolume: (state) => state.fillVolume,
};

const mutations = {
	update_design_file_name(state, designFilename) {
		state.designFilename = designFilename;
	},
	update_point_cloud_item(state, pointCloudItem) {
		state.pointCloudItem = pointCloudItem;
	},
	update_terrain_items(state, terrainItems) {
		state.terrainItems = terrainItems;
	},
	update_is_ai_road_preview_mode(state, isAIRoadPreviewMode) {
		state.isAIRoadPreviewMode = isAIRoadPreviewMode;
	},
	update_chat_context(state, chatContext) {
		state.chatContext = chatContext;
	},
	add_chat_message(state, message) {
		state.chatContext.push(message);
	},
	add_post_chat_message(state, message) {
		state.postChatContext.push(message);
	},
	clear_chat_context(state) {
		state.chatContext = [];
	},
	clear_post_chat_context(state) {
		state.postChatContext = [];
	},
	update_point_cloud_asset_id(state, pointCloudAssetId) {
		state.pointCloudAssetId = pointCloudAssetId;
	},
	update_command_id(state, commandId) {
		state.commandId = commandId;
	},
	update_route(state, route) {
		state.route = route;
	},
	update_grade(state, grade) {
		state.grade = grade;
	},
	update_width(state, width) {
		state.width = width;
	},
	// 新方式（D3D-774）
	update_objectives(state, objectives) {
		state.objectives = objectives;
	},
	update_road_width_m(state, roadWidthM) {
		state.roadWidthM = roadWidthM;
	},
	update_max_slope_percent(state, maxSlopePercent) {
		state.maxSlopePercent = maxSlopePercent;
	},
	update_ai_start(state, aiStart) {
		state.aiStart = aiStart;
	},
	update_ai_end(state, aiEnd) {
		state.aiEnd = aiEnd;
	},
	update_waypoints(state, waypoints) {
		state.waypoints = waypoints;
	},
	update_mode(state, mode) {
		state.mode = mode;
	},
	update_data_selection(state, dataSelection) {
		state.dataSelection = dataSelection;
	},
	update_point_cloud_only_requested(state, requested) {
		state.pointCloudOnlyRequested = requested;
	},
	update_candidate_state(state, candidateState) {
		state.candidateState = candidateState;
	},
	update_diagnostics(state, diagnostics) {
		state.diagnostics = diagnostics;
	},
	update_used_source(state, usedSource) {
		state.usedSource = usedSource;
	},
	update_job_handle(state, jobHandle) {
		state.jobHandle = jobHandle;
	},
	update_run_error(state, runError) {
		state.runError = runError;
	},
	update_is_running(state, isRunning) {
		state.isRunning = isRunning;
	},
	update_point_cloud_id(state, pointCloudId) {
		state.pointCloudId = pointCloudId;
	},
	update_design_id(state, designId) {
		state.designId = designId;
	},
	update_ai_parameter_field(state, inputTextField) {
		state.aiParameter = { ...state.aiParameter, inputTextField };
	},
	update_ai_parameter(state, payload) {
		state.aiParameter = {
			...state.aiParameter,
			...payload,
		};
	},
	update_ai_parameter_input_text_field(state, payload) {
		state.aiParameter.inputTextField = {
			...state.aiParameter.inputTextField,
			...payload,
		};
	},
	reset_ai_parameter(state) {
		state.aiParameter = {
			isComplete: false,
			file: null,
			isTempRoadBtnDisabled: true,
			inputTextField: {
				xValueMin: "",
				xValueMax: "",
				yValueMin: "",
				yValueMax: "",
				xyInterval: "",
				zValueMin: "",
				zValueMax: "",
				zInterval: "",
				allowMaxGradient: "",
				searchExpansionRadius: "",
			},
			terrainInfo: null,
			sliderMin: 0.1,
			sliderMax: 1.0,
			sliderStep: 0.01,
			sliderValueCut: 0.1,
			sliderValueFill: 0.1,
			sliderValueOverFill: 0.1,
			sliderValueOverCut: 0.1,
			sliderValueCfDiff: 1.0,
			sliderValueRoute: 0.1,
		};
	},
	update_left_with(state, leftWith) {
		state.leftWith = leftWith;
	},
	update_right_with(state, rightWith) {
		state.rightWith = rightWith;
	},
	update_cut_volume(state, cutVolume) {
		state.cutVolume = cutVolume;
	},
	update_fill_volume(state, fillVolume) {
		state.fillVolume = fillVolume;
	},
};

const actions = {
	update_design_file_name({ commit }, designFilename) {
		commit("update_design_file_name", designFilename);
	},
	update_point_cloud_item({ commit }, pointCloudItem) {
		commit("update_point_cloud_item", pointCloudItem);
	},
	update_terrain_items({ commit }, terrainItems) {
		commit("update_terrain_items", terrainItems);
	},
	update_is_ai_road_preview_mode({ commit }, isAIRoadPreviewMode) {
		commit("update_is_ai_road_preview_mode", isAIRoadPreviewMode);
	},
	update_chat_context({ commit }, chatContext) {
		commit("update_chat_context", chatContext);
	},
	add_chat_message({ commit }, message) {
		commit("add_chat_message", message);
	},
	clear_chat_context({ commit }) {
		commit("clear_chat_context");
	},
	add_post_chat_message({ commit }, message) {
		commit("add_post_chat_message", message);
	},
	clear_post_chat_context({ commit }) {
		commit("clear_post_chat_context");
	},
	update_point_cloud_asset_id({ commit }, pointCloudAssetId) {
		commit("update_point_cloud_asset_id", pointCloudAssetId);
	},
	update_command_id({ commit }, commandId) {
		commit("update_command_id", commandId);
	},
	update_route({ commit }, route) {
		commit("update_route", route);
	},
	update_grade({ commit }, grade) {
		commit("update_grade", grade);
	},
	update_width({ commit }, width) {
		commit("update_width", width);
	},
	// 新方式（D3D-774）
	update_objectives({ commit }, objectives) {
		commit("update_objectives", objectives);
	},
	update_road_width_m({ commit }, roadWidthM) {
		commit("update_road_width_m", roadWidthM);
	},
	update_max_slope_percent({ commit }, maxSlopePercent) {
		commit("update_max_slope_percent", maxSlopePercent);
	},
	update_ai_start({ commit }, aiStart) {
		commit("update_ai_start", aiStart);
	},
	update_ai_end({ commit }, aiEnd) {
		commit("update_ai_end", aiEnd);
	},
	update_waypoints({ commit }, waypoints) {
		commit("update_waypoints", waypoints);
	},
	update_mode({ commit }, mode) {
		commit("update_mode", mode);
	},
	update_data_selection({ commit }, dataSelection) {
		commit("update_data_selection", dataSelection);
	},
	update_point_cloud_only_requested({ commit }, requested) {
		commit("update_point_cloud_only_requested", requested);
	},
	update_candidate_state({ commit }, candidateState) {
		commit("update_candidate_state", candidateState);
	},
	update_diagnostics({ commit }, diagnostics) {
		commit("update_diagnostics", diagnostics);
	},
	update_used_source({ commit }, usedSource) {
		commit("update_used_source", usedSource);
	},
	update_job_handle({ commit }, jobHandle) {
		commit("update_job_handle", jobHandle);
	},
	update_run_error({ commit }, runError) {
		commit("update_run_error", runError);
	},
	update_is_running({ commit }, isRunning) {
		commit("update_is_running", isRunning);
	},
	update_point_cloud_id({ commit }, pointCloudId) {
		commit("update_point_cloud_id", pointCloudId);
	},
	update_design_id({ commit }, designId) {
		commit("update_design_id", designId);
	},
	update_ai_parameter_field({ commit }, payload) {
		commit("update_ai_parameter_field", payload);
	},
	update_ai_parameter({ commit }, payload) {
		commit("update_ai_parameter", payload);
	},
	update_ai_parameter_input_text_field({ commit }, payload) {
		commit("update_ai_parameter_input_text_field", payload);
	},
	reset_ai_parameter({ commit }) {
		commit("reset_ai_parameter");
	},
	update_left_with({ commit }, leftWith) {
		commit("update_left_with", leftWith);
	},
	update_right_with({ commit }, rightWith) {
		commit("update_right_with", rightWith);
	},
	update_cut_volume({ commit }, cutVolume) {
		commit("update_cut_volume", cutVolume);
	},
	update_fill_volume({ commit }, fillVolume) {
		commit("update_fill_volume", fillVolume);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
